import React, { useEffect, useState } from "react";
import {
  Image,
  Pressable,
  StyleSheet,
  Text,
  View,
  Modal,
  InteractionManager,
  NativeModules,
  Alert,
  Platform,
  ActivityIndicator,
  ScrollView,
} from "react-native";
import Spinner from "react-native-spinkit";
import Search from "@assets/svg/Search";
import color from "@constants/color";
import t from "@constants/localization";
import metrics from "@constants/metrics";
import Pin from "../../assets/images/LocationPin";
import LocationImage from "@assets/svg/LocationImage";
import CustomText from "@components/CustomText";
import getCurrentLocation from "@utils/getCurrentLocation";
import { check, request, PERMISSIONS, RESULTS } from "react-native-permissions";
import analytics from "@services/analytics";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useDispatch } from "react-redux";
import { actions as authActions } from "@reducers/authReducer";
import { LOCATION_EVENTS } from "@constants/analyticsEventsCT";
import { getUserDetails, saveDeviceLocation } from "@services/api";
import LocationCity from "@assets/svg/LocationCity";
import { fontFamily } from "@utils/styles/fonts";
import PartersCitymallIcon from "@assets/svg/PartersCitymallIcon";
import FastImage from "react-native-fast-image";
import { scale } from "@utils/scale";

const ImageComponent = FastImage;

const PATH = "screens/LocationWithoutAddress/index";

const onPermissionDeniedPerm = () => {
  const { AppSettingsIntentModule } = NativeModules;
  Alert.alert(
    "Permissions denied",
    "Please grant us Location permission",
    [
      {
        text: "Go to settings",
        onPress: () => {
          analytics.trackEvent(LOCATION_EVENTS.ANDROID_SETTINGS);
          AppSettingsIntentModule.openAppSettings();
        },
      },
      {
        text: "Cancel",
        onPress: () => {},
      },
    ],
    {
      cancelable: true,
    },
  );
};

const ModalPoup = ({ visible, children }) => {
  const [showModal, setShowModal] = useState(visible);
  useEffect(() => {
    handleModal();
  }, [visible]);
  const handleModal = () => {
    if (visible) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  };
  return (
    <Modal transparent visible={showModal}>
      <View style={styles.modalBackGround}>
        <View style={[styles.modalContainer]}>{children}</View>
      </View>
    </Modal>
  );
};

const LocationWithoutAddress = ({ navigation, route }) => {
  const {
    fromSignUp = true,
    fromProfile = false,
    fromNotServiceable = false,
    fromDrawer = false,
  } = route?.params ?? {};

  const [lat, setLat] = useState(0);
  const [lng, setLng] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const [permissionModalVisible, setPermissionDeniedModalVisible] =
    useState(false);

  const [imgLoader, setImgLoader] = useState(false);

  useEffect(() => {
    const task = InteractionManager.runAfterInteractions(() => {
      analytics.trackEvent(LOCATION_EVENTS.LANDING);
    });
    return () => task.cancel();
  }, []);

  const handleGetLocationError = () => {
    Alert.alert(
      "",
      t("location/tryAgain"),
      [
        {
          onPress: getLocation,
          text: t("location/ok"),
        },
      ],
      { cancelable: false },
    );
  };

  const fetchAndSetLocation = async () => {
    setIsSubmitting(true);
    try {
      const position = await getCurrentLocation({ timeoutMs: 20000 });
      setLat(position.coords.latitude);
      setLng(position.coords.longitude);
      saveLocation(position.coords.latitude, position.coords.longitude);
    } catch {
      handleGetLocationError();
      setIsSubmitting(false);
    }
  };

  const getLocation = async () => {
    if (Platform.OS === "android") {
      const status = await check(PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION);
      if (status === RESULTS.GRANTED) {
        fetchAndSetLocation();
      } else {
        const result = await request(PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION);
        if (result === RESULTS.GRANTED) {
          analytics.trackEvent(LOCATION_EVENTS.PERMISSION_GRANTED);
          fetchAndSetLocation();
        } else if (result === RESULTS.DENIED) {
          setPermissionDeniedModalVisible(true);
          analytics.trackEvent(LOCATION_EVENTS.PERMISSION_DENIED);
        } else if (result === RESULTS.BLOCKED) {
          onPermissionDeniedPerm();
          analytics.trackEvent(LOCATION_EVENTS.PERMISSION_DENIED);
          dispatch(miscActions.showSettingsModal());
        }
      }
    }
  };

  const saveLocation = async (lat, lng) => {
    setIsSubmitting(true);
    const body = {
      latitude: lat,
      longitude: lng,
    };

    if (body.latitude === null || body.longitude === null) {
      handleGetLocationError();
      return;
    }

    saveDeviceLocation(body)
      .then(async (res) => {
        analytics.trackEvent(LOCATION_EVENTS.SUBMITTED, body);
        return getUserDetails();
      })
      .then(async (res) => {
        console.log("----- final res is ------", res);
        const { is_serviceable } = res.data;
        if (fromSignUp) {
          await AsyncStorage.removeItem("newlyCreatedUser");
          await AsyncStorage.removeItem("isUserLoggedInFirst");
          dispatch(authActions.removeNewUserRequest());
        }
        setIsSubmitting(false);

        if (!is_serviceable) {
          analytics.trackEvent(LOCATION_EVENTS.NOT_SERVICEABLE_SIGNUP, body);
          navigation.replace("NotServicable");
        } else {
          analytics.trackEvent(LOCATION_EVENTS.SERVICEABLE_SIGNUP, body);
          dispatch(authActions.getUserDetailsByTokenRequest({}));
        }
      })
      .catch((err) => {
        console.log("error in location", err);
        setIsSubmitting(false);
      });
  };

  const handleModalVisibility = () => {
    setPermissionDeniedModalVisible(false);
    getLocation();
  };

  return (
    <View style={styles.mainContainer}>
      <ScrollView
        contentContainerStyle={styles.contentContainerStyle}
        showsHorizontalScrollIndicator={false}
        showsVerticalScrollIndicator={false}
        style={styles.container}
      >
        <ModalPoup visible={permissionModalVisible}>
          <View style={{ paddingTop: 27, alignItems: "center" }}>
            <LocationImage />
          </View>

          <View style={{ paddingLeft: 20, paddingBottom: 15, paddingTop: 35 }}>
            <CustomText
              style={{
                fontSize: 14,
                textAlign: "center",
              }}
            >
              {t(`${PATH}/knowYourCityMall`)}
            </CustomText>
          </View>
          <Pressable
            style={styles.submitModalButton}
            onPress={handleModalVisibility}
          >
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Text style={styles.submitModalButtonText}>
                लोकेशन की परमिशन दें
              </Text>
            </View>
          </Pressable>
        </ModalPoup>
        <View style={styles.gifContainer}>
          <ImageComponent
            style={styles.mapGIFStyle}
            source={{
              uri: "https://public-cdn.citymall.live/cm-admin-storage-public/1665740464096-c3-3.gif",
            }}
            onLoadStart={() => setImgLoader(true)}
            onLoadEnd={() => setImgLoader(false)}
            onError={() => setImgLoader(false)}
          />
          {imgLoader ? (
            <View style={styles.imgLoader}>
              <ActivityIndicator size={"large"} color={color.plain_red} />
            </View>
          ) : null}
        </View>
        <View style={styles.cityServiceContainer}>
          <LocationCity />
          <Text style={styles.cityText}>
            {t(`${PATH}/moreCityService`, { number: 30 })}
          </Text>
        </View>
        <View
          style={[
            styles.cityServiceContainer,
            {
              marginLeft: 40,
              marginTop: 12,
            },
          ]}
        >
          <PartersCitymallIcon />
          <Text style={styles.cityText}>
            {t(`${PATH}/cityMallParters`, { number: 20 })}
          </Text>
        </View>
        <View style={styles.bottomContainer}>
          <Text style={styles.aboutPermission}>
            {t(`${PATH}/knowYourCityMall`)}
          </Text>
        </View>
      </ScrollView>
      <View style={styles.buttonContainer}>
        {isSubmitting ? (
          <Pressable style={styles.submitButton}>
            <ActivityIndicator size={"large"} color="white" />
          </Pressable>
        ) : (
          <Pressable style={styles.submitButton} onPress={getLocation}>
            <Pin />
            <Text style={styles.submitButtonText}>
              {t(`${PATH}/locationType`)}
            </Text>
          </Pressable>
        )}
      </View>
    </View>
  );
};

export default LocationWithoutAddress;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainerStyle: {
    flexGrow: 1,
    backgroundColor: color.white,
    paddingBottom: 50,
  },
  modalBackGround: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    width: "90%",
    backgroundColor: "white",
    padding: 20,
    justifyContent: "center",
    alignContent: "center",
    borderRadius: 10,
    elevation: 20,
  },
  submitModalButton: {
    paddingVertical: 12,
    backgroundColor: "#E40046",
    borderRadius: 6,
    minWidth: "75%",
    margin: 20,
    marginBottom: 8,
    alignItems: "center",
  },
  submitModalButtonText: {
    fontFamily: "Mulish-Bold",
    color: "white",
    fontSize: 20,
    lineHeight: 28,
  },
  submitButton: {
    paddingVertical: 12,
    backgroundColor: "#E40046",
    borderRadius: 10,
    marginHorizontal: 16,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "90%",
  },
  submitButtonText: {
    fontFamily: "Mulish-Bold",
    color: "white",
    fontSize: 20,
    lineHeight: 28,
    marginLeft: 8,
  },
  innerContaier: {
    backgroundColor: color.white,
    flex: 1,
  },
  cityServiceContainer: {
    paddingHorizontal: 24,
    flexDirection: "row",
    alignItems: "center",
    marginTop: 30,
  },
  cityText: {
    fontFamily: fontFamily.semiBold,
    fontSize: 18,
    color: color.mediumBlack,
    marginStart: 18,
  },
  aboutPermission: {
    fontFamily: fontFamily.regular,
    fontSize: 22,
    color: color.mediumBlack,
    textAlign: "center",
    marginTop: 40,
  },
  bottomContainer: {
    paddingHorizontal: 16,
  },
  gifContainer: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: color.white,
    marginTop: 70,
  },
  mapGIFStyle: {
    minHeight: scale(190),
    width: "100%",
    backgroundColor: color.white,
  },
  imgLoader: {
    alignItems: "center",
    justifyContent: "center",
    zIndex: 100,
    position: "absolute",
    alignSelf: "center",
  },
  mainContainer: {
    flex: 1,
    backgroundColor: color.white,
  },
  buttonContainer: {
    paddingTop: 16,
    paddingBottom: 30,
  },
});
